import styled from "styled-components";

export const StyledPartialText = styled.div<{ height: number }>`
    height: ${({ height }) => height}px;
`;

export const StyledPartialTextCollapsable = styled.div<{ height: number; isCollapsed: boolean }>`
    max-height: ${({ isCollapsed, height }) => (isCollapsed ? `${height}px` : "1000px")};
    overflow: hidden;
    transition: max-height 0.3s ease;
`;

export const StyledExpandCollapseButton = styled.a`
    cursor: pointer;
    color: inherit;
    font: inherit;
    font-weight: 700;
`;
